import { useState, useEffect, useCallback } from 'react';

import { getGroupTransforms, getTranslateValues } from '../../utils/transformHelpers';
import { STATIC_TABLE_ELEMENT } from '../../utils/complexDocumentConstants';

const useContextMenu = (documentId, scaling, multiSelectedElementIds, textBlock, staticTable, disableVariables = false) => {
  const [xPos, setXPos] = useState('0px');
  const [yPos, setYPos] = useState('0px');
  const [elementId, setElementId] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  const [element, setElement] = useState(null);
  const [showMultiElementsMenu, setShowMultiElementsMenu] = useState(false);
  const [isSingleElementOfGroupSelected, setIsSingleElementOfGroupSelected] = useState(false);

  const handleContextMenu = useCallback(
    e => {
      if (!e) return;
      e.preventDefault();
      const moveableAreaElement = e.target.closest('.moveable-area');
      const selectableElement = e.target.closest('.selectable');
      if (moveableAreaElement && multiSelectedElementIds && multiSelectedElementIds.length > 1) {
        const target = moveableAreaElement.parentElement;
        const { x, y } = getTranslateValues(target);
        const xPos = parseInt(x) + e.offsetX;
        const yPos = parseInt(y) + e.offsetY;
        setElement(null);
        setXPos(`${xPos}px`);
        setYPos(`${yPos}px`);
        setElementId('');
        setShowMenu(true);
        setShowMultiElementsMenu(true);
        setIsSingleElementOfGroupSelected(false);
      } else if (selectableElement) {
        let targetElement = selectableElement;
        let left = 0, top = 0;
        if (targetElement.getAttribute('data-element-type') === STATIC_TABLE_ELEMENT) {
          if (e.target.tagName !== 'TD') {
            //when clicking in between the static table element, table cell could be null.
            const tableCell = e.target.closest('TD') || {};
            left = tableCell.offsetLeft || 0;
            top = tableCell.offsetTop || 0;
          } else {
            left = e.target.offsetLeft;
            top = e.target.offsetTop;
          }
        }
        if (targetElement.classList.contains('block-selectable')) {
          targetElement = targetElement.parentElement.parentElement;
        }
        console.log("e.target :: ", e.target, e.offsetY);
        const targetElementId = targetElement.getAttribute('data-uuid');
        setElement(targetElement);
        const { x, y } = getTranslateValues(targetElement);
        if (x && y && targetElementId && multiSelectedElementIds.length && multiSelectedElementIds.includes(targetElementId)) {
          setXPos(`${left + e.offsetX + parseInt(x)}px`);
          setYPos(`${top + e.offsetY + parseInt(y)}px`);
          setElementId(targetElementId);
          setShowMenu(true);
          setShowMultiElementsMenu(false);
          if (multiSelectedElementIds.length > 1) {
            setIsSingleElementOfGroupSelected(true);
          }
        } else if (staticTable) {
          targetElement = e.target.closest('TABLE');
          const tableBoundary = targetElement.getBoundingClientRect();
          setXPos(`${e.clientX - tableBoundary.x}px`);
          setYPos(`${e.clientY - tableBoundary.y}px`);
          setElementId(targetElementId);
          setShowMenu(true);
          setShowMultiElementsMenu(false);
          setIsSingleElementOfGroupSelected(false);
        }
      } else if (textBlock) {

        let editorRef = textBlock.editorRef;

        if (disableVariables) return;
        
        if (editorRef) {
          let editor = editorRef?.current?.getEditor();

          let range = editor?.getSelection();

          if (range) {
            let boundary = editor?.getBounds(editor?.getSelection());
            console.log('boundary', boundary);
            let xpos = boundary.left + boundary.width;
            const editorWidth = editor.container.offsetWidth;
            const totalXpos = editorWidth - xpos;
            if (totalXpos < 230) {  // Total width of context menu is 230px
              const posVal = 230 - totalXpos;
              xpos = xpos - posVal;
              setXPos(`${xpos}px`);
              setYPos(`${boundary.top + 20}px`);
            } else {
              setXPos(`${boundary.left + boundary.width}px`);
              setYPos(`${boundary.top}px`);
            }
          }
        }
        setShowMenu(true);

      } else {
        setShowMenu(false);
        setShowMultiElementsMenu(false);
        setIsSingleElementOfGroupSelected(false);
      }
    },
    [scaling, multiSelectedElementIds, disableVariables, documentId],
  );

  const handleClick = useCallback(() => {
    setShowMenu(previousValue => {
      if (previousValue) return false;
      return previousValue;
    })
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  useEffect(() => {
    if (document.getElementById(documentId)) {
      document
        .getElementById(documentId)
        .addEventListener('contextmenu', handleContextMenu);
    }
    if (document.getElementsByClassName('moveable-area')?.[0]) {
      document
        .getElementsByClassName('moveable-area')[0]
        .addEventListener('contextmenu', handleContextMenu);
    }

    return () => {
      if (document.getElementById(documentId)) {
        document
          .getElementById(documentId)
          .removeEventListener('contextmenu', handleContextMenu);
      }
      if (document.getElementsByClassName('moveable-area')?.[0]) {
        document
          .getElementsByClassName('moveable-area')[0]
          .removeEventListener('contextmenu', handleContextMenu);
      }
    };
  }, [showMenu, documentId, handleClick, handleContextMenu]);
  return { xPos, yPos, elementId, showMenu, element, showMultiElementsMenu, setShowMenu, isSingleElementOfGroupSelected };
};

export default useContextMenu;
